import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 67.478 100"
    ref={ref}
    {...props}
  >
    <path d="M7.71.04a8.54 8.54 0 0 0-5.766 3.073 8.537 8.537 0 0 0 1.17 12.015L45.506 50 3.114 84.87a8.537 8.537 0 0 0-1.17 12.016 8.537 8.537 0 0 0 12.015 1.17L64.366 56.59a8.537 8.537 0 0 0 0-13.184L13.959 1.943A8.54 8.54 0 0 0 7.71.04" />
  </svg>
);
const ForwardRef = forwardRef(SvgArrowRight);
export default ForwardRef;
